import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "../pages/Bookings/booking.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Card } from "react-bootstrap";
import OnlyCalendar from "../pages/commoncontrols/OnlyCalendar";

export default function BookingEngine(
  {
    setLandingData,
    ServiceSubmit,
    EventSubmit,
    ClassSubmit,
    RoomSubmit,
    viaActiveTab,
    getselectedData,
    ClickTab,
    defaultValue,
  },
  props
) {
  const tabs = ["rooms", "services", "events", "class"];
  const locale = localStorage.getItem("locale")
  const [showFilterPopUp, ShowFilterPopup] = useState(false);
  const [selectedTab, setSelectedTab] = useState();
  const [showErr, setShowErr] = useState(false);
  const [storeDate, setStoreDate] = useState();
  const [activeTab, setActiveTab] = useState(null);
  const [inputDefaultVal, setInputDefaultVal] = useState("");

  useEffect(() => {
    const locale = localStorage.getItem("locale")
    if (defaultValue) {
      const todayDateString = moment(defaultValue.todayDate?._d).format("YYYY-MM-DD");
      const tomorrowDateString = moment(defaultValue.tomorrowDate?._d).format("YYYY-MM-DD");

      setValue("checkindate", new Date());
      setValue("checkoutdate", moment().add(1, "days"));
    }
  }, [defaultValue]);

  useEffect(() => {
    const linkTo =
      setLandingData?.menu?.Rooms === "rooms"
        ? "rooms"
        : setLandingData?.menu?.Services === "service"
        ? "service"
        : setLandingData?.menu?.Events === "events"
        ? "events"
        : setLandingData?.menu?.Class === "class"
        ? "class"
        : null;

    setSelectedTab(linkTo);
    setActiveTab(linkTo);
  }, [setLandingData]);

  const {
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  const validateDates = (data) => {
    const errors = {};
    if (!data.checkindate) {
      errors.checkindate = "Checkin date is required";
    }
    if (!data.checkoutdate) {
      errors.checkoutdate = "Checkout date is required";
    } else if (new Date(data.checkindate) > new Date(data.checkoutdate)) {
      errors.checkoutdate = "Checkout date must be after checkin date";
    }
    return errors;
  };

  function handleClickTab(linkTo) {
    setSelectedTab(linkTo);
    setShowErr(false);
    setStoreDate(null);
    setActiveTab(linkTo);
    ClickTab(linkTo);
  }

  const propsdata = (data) => {
    if (data) {
      let tomorrowdate = moment(new Date(data.selectedcheckindate)).add(
        1,
        "days"
      );
      if (data.id === "checkindate" && data.selectedcheckindate !== undefined) {
        setValue("checkindate", data.selectedcheckindate);
        setValue("checkoutdate", tomorrowdate.format("MM/DD/YYYY"));
      } else {
        setValue("checkoutdate", data.selectedcheckoutdate);
      }
    }
  };

  const handleDateChange = (date, id) => {
    if (id === "checkindate") {
      const nextDay = moment(date).add(1, "days").toDate();
      setValue("checkindate", date);
      setValue("checkoutdate", nextDay);
    } else if (id === "checkoutdate") {
      const checkInDate = watch("checkindate");
      if (moment(date).isAfter(moment(checkInDate), "day")) {
        setValue("checkoutdate", date);
      } else {
        toast("Invalid date", { autoClose: 1500 });
      }
    }
  };

  function handleDatePicker(data) {
    setStoreDate(data);
  }

  function checkErr(event, submitFunction, data) {
    event.preventDefault();
    if (!storeDate) {
      setShowErr(true);
    } else {
      setShowErr(false);
      submitFunction(event, data);
    }
  }

  function handleServiceSubmit(event) {
    checkErr(event, ServiceSubmit, storeDate);
  }

  function handleEventSubmit(event) {
    checkErr(event, EventSubmit, storeDate);
  }

  function handleClassSubmit(event) {
    checkErr(event, ClassSubmit, storeDate);
  }

  const FormSubmit = async (data, event) => {
    const validationErrors = validateDates(data);
    if (Object.keys(validationErrors).length > 0) {
      Object.entries(validationErrors).forEach(([key, message]) => {
        toast.error(message, { autoClose: 1500 });
      });
      return;
    }
    setValue("checkindate", data.checkindate);
    setValue("checkoutdate", data.checkoutdate);
    RoomSubmit(data, event, storeDate);
    ShowFilterPopup(true);
  };

  const checkInDate = watch("checkindate");

  return (
    <Card>
      <div className="four_tab_container px-3 pt-3">
        {tabs?.map((item, index) => {
          const linkLabel =
            item === "rooms" && setLandingData?.menu?.Rooms === "rooms"
              ? "Room"
              : item === "services" &&
                setLandingData?.menu?.Services === "service"
              ? "service"
              : item === "events" && setLandingData?.menu?.Events === "events"
              ? "Events"
              : item === "class" && setLandingData?.menu?.Class === "class"
              ? "Class"
              : null;

          const linkTo =
            item === "rooms" && setLandingData?.menu?.Rooms === "rooms"
              ? "rooms"
              : item === "services" &&
                setLandingData?.menu?.Services === "service"
              ? "service"
              : item === "events" && setLandingData?.menu?.Events === "events"
              ? "events"
              : item === "class" && setLandingData?.menu?.Class === "class"
              ? "class"
              : null;

          return linkLabel ? (
            <div
              className={`tab_self_container ${
                linkTo === activeTab ? "tab_active" : ""
              }`}
              key={index}
              onClick={() => handleClickTab(linkTo)}
            >
              {linkLabel}
            </div>
          ) : null;
        })}
      </div>

      <div className="tab_body_container">
        {/* rooms */}
        {selectedTab === "rooms" && (
          <form onSubmit={handleSubmit(FormSubmit)}>
            <div className="py-3  px-5 membroz-form d-flex align-items-end">
              <div className="col-lg-12 col-md-12">
                <div className="row wl-gutters-5">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                    <div className="form-group ">
                      <label className="wl-label">Check In</label>
                      <DatePicker
                        selected={watch("checkindate")}
                        onChange={(date) => handleDateChange(date, "checkindate")}
                        minDate={new Date()}
                        dateFormat={locale === "en-US" ? "MM-dd-yyyy" : "dd-MM-yyyy"}
                        placeholderText={locale === "en-US" ? "MM-DD-YYYY" : "DD-MM-YYYY"}
                        className="form-control py-3 px-3 border-right-0 date_input"
                      />
                    </div>

                    <span className="errorMessage">
                      {errors.checkindate?.message}
                    </span>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6">
                    <div className="form-group">
                      <label className="wl-label">Check Out</label>
                      <DatePicker
                        selected={watch("checkoutdate")}
                        onChange={(date) => handleDateChange(date, "checkoutdate")}
                        minDate={new Date()}
                        dateFormat={locale === "en-US" ? "MM-dd-yyyy" : "dd-MM-yyyy"}
                        placeholderText={locale === "en-US" ? "MM-DD-YYYY" : "DD-MM-YYYY"}
                        className="form-control py-3 px-3 border-right-0 date_input"
                      />
                    </div>
                    <span className="errorMessage">
                      {errors.checkoutdate?.message}
                    </span>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 d-flex align-items-center">
                    <button
                      type="submit"
                      className="btn mt-3 btn-primary btn-lg btn-lg-ca availability_btn"
                    >
                      Check Availability
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
        {/* service */}

        {selectedTab === "service" && (
          <div>
            <form
              className=" row py-3 px-3 d-flex align-items-center"
              onSubmit={handleServiceSubmit}
            >
              <div className="col-xl-8 col-lg-8 col-md-8 col-sm-6 d-flex align-items-end">
                <DatePicker
                  defaultVal={inputDefaultVal}
                  onChange={handleDatePicker}
                  labelName="Select date"
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 d-flex pl-0 pt-3 ">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg btn-lg-ca availability_btn"
                >
                  Check availability
                </button>
              </div>
              {showErr && (
                <span className="errorMessage ml-3">Please pick a date</span>
              )}
            </form>
          </div>
        )}

        {/* Events */}

        {selectedTab === "events" && (
          <div>
            <form
              className=" row py-3 px-3 d-flex align-items-center"
              onSubmit={handleEventSubmit}
            >
              <div className="col-xl-8 col-lg-8 col-md-8 col-sm-6 d-flex align-items-end">
                <DatePicker
                  defaultVal={inputDefaultVal}
                  onChange={handleDatePicker}
                  labelName="Select date"
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 d-flex pl-0 pt-3 ">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg btn-lg-ca availability_btn"
                >
                  Check availability
                </button>
              </div>
              {showErr && (
                <span className="errorMessage ml-3">Please pick a date</span>
              )}
            </form>
          </div>
        )}
        {/* Class */}

        {selectedTab === "class" && (
          <div>
            <form
              className=" row py-3 px-3 d-flex align-items-center"
              onSubmit={handleClassSubmit}
            >
              <div className="col-xl-8 col-lg-8 col-md-8 col-sm-6 d-flex align-items-end">
                <DatePicker
                  defaultVal={inputDefaultVal}
                  onChange={handleDatePicker}
                  labelName="Select date"
                />
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 d-flex pl-0 pt-3 ">
                <button
                  type="submit"
                  className="btn btn-primary btn-lg btn-lg-ca availability_btn"
                >
                  Check availability
                </button>
              </div>
              {showErr && (
                <span className="errorMessage ml-3">Please pick a date</span>
              )}
            </form>
          </div>
        )}
      </div>
    </Card>
  );
}
